import get from 'lodash.get';

// When combining asserts as "or" they are valid if one is true
// So they all have to fail to return false
export const orAsserts = asserts => value => asserts.map(fn => fn(value)).some(bool => bool);

export const isNull = value => value === null;
export const isNotNull = value => !isNull(value);
export const isUndefined = value => typeof value === 'undefined';
export const isString = value => typeof value === 'string';
export const isEmptyString = value => value === '';
export const isNotEmptyString = value => !isEmptyString(value);
export const isMinimumLength = length => {
  return value => isString(value) && value.length > length;
};
export const isNotOneOf = values => {
  return value => values.indexOf(value) === -1;
};
export const isNot = testValue => {
  return value => value !== testValue;
};
export const emptyOr = fn => orAsserts([isNull, isUndefined, isEmptyString, fn]);

export const assert = (fn, message) => {
  return (item, name) => {
    if (!fn(get(item, name))) {
      return message;
    }
    return undefined;
  };
};
